import { Box, Button, Typography, useTheme } from "@mui/material";
import { LogoOnly } from "@/Assets/LogoOnly";
import { CompanyType } from "@/Enums/CompanyType";
import { companyType } from "@/Utils/environment";
import { magicLinkPageOuterSx } from "@/Utils/MagicLink/pageLayout";

const companyHomeLink = companyType === CompanyType.KOMUNALNA
    ? { href: "https://www.kpas.sk", label: "kpas.sk" }
    : { href: "https://www.kooperativa.sk", label: "kooperativa.sk" };

const PublicNotFoundView = () => {
    const theme = useTheme();

    return (
        <Box
            component="main"
            sx={{
                ...magicLinkPageOuterSx,
                minHeight: "100dvh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 480,
                    backgroundColor: theme.palette.background.default,
                    borderRadius: "7px",
                    padding: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    gap: 2,
                }}
            >
                <LogoOnly width={56} height={48} />

                <Typography variant="h4" color={theme.palette.error.main}>
                    Stránka sa nenašla
                </Typography>

                <Typography variant="body1" color="text.secondary">
                    Požadovaná adresa neexistuje alebo už nie je dostupná.
                </Typography>

                <Button
                    component="a"
                    href={companyHomeLink.href}
                    variant="contained"
                    color="primary"
                    sx={{
                        mt: 1,
                        width: "fit-content",
                        height: 48,
                        minHeight: 48,
                    }}
                >
                    {companyHomeLink.label}
                </Button>
            </Box>
        </Box>
    );
};

export default PublicNotFoundView;
